import React from 'react'
import PropTypes from 'prop-types'
import {Icon, IconButton} from "@material-ui/core"
import {useTheme} from '@material-ui/core/styles'
import ReactLoading from 'react-loading'


const DefaultBookmarkButton = (props) => {
    const theme = useTheme()
    const {inProgress, isBookmarked, onClick } = props
    return (
        <IconButton
            aria-label="bookmark the product"
            color="primary"
            onClick={onClick}
        >
            {!!inProgress ?
                <ReactLoading type={'spokes'} color={theme.palette.primary.main} height={21} width={20}  />:
                <>
                    {!!isBookmarked ? <Icon>favorite_icon</Icon> : <Icon>favorite_border_icon</Icon>}
                </>
            }
        </IconButton>
    )
}


DefaultBookmarkButton.propTypes = {
    inProgress: PropTypes.bool,
    isBookmarked: PropTypes.bool,
    onClick: PropTypes.func.isRequired

}

export default DefaultBookmarkButton
